interface IUserMessageProps {
  message: string;
}

function UserMessage(props: IUserMessageProps) {
  return (
    <div className="question-message-container w-[calc(100%-20px)] md:w-3/4 text-[0.8rem] self-end relative whitespace-normal break-words bg-xircle-secondary text-white mr-5 mb-3 p-3 rounded-xl">
      {props.message}
    </div>
  );
}

export default UserMessage;
